import { render, staticRenderFns } from "./deliveryDetailModal.vue?vue&type=template&id=fbec319e"
import script from "./deliveryDetailModal.vue?vue&type=script&lang=js"
export * from "./deliveryDetailModal.vue?vue&type=script&lang=js"
import style0 from "./deliveryDetailModal.vue?vue&type=style&index=0&id=fbec319e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports